var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('transition',{attrs:{"name":"eqs-slide-from-right"}},[_c('router-view',_vm._b({on:{"close":_vm.closeDialog}},'router-view',{ loading: _vm.loading },false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }